import { styled } from "@mui/material";
import LinearProgress, {
	linearProgressClasses
} from "@mui/material/LinearProgress";

export const Container = styled("div")`
	position: absolute;
	//bottom: 0.95em;
	//left: 6.5em;
	bottom: 1%;
	font-size: 1em;
	width: 100%;
	height: 1.2em;
	z-index: 3;
`;

export const BorderLinearProgress = styled(LinearProgress)`
	position: relative;
	height: 100%;
	border-radius: 26px;
	background-color: #0b577a;
	border: 0.099em solid #ffffff;
	//box-sizing: border-box;

	& .${linearProgressClasses.bar} {
		border-radius: 26px;
		/* background-image: linear-gradient(
			180deg,
			#ffe179 0%,
			#ffc56d 30.73%,
			#ffb800 43.75%,
			#ff8100 100%
		); */
		background-image: linear-gradient(
			180deg,
			#74eb38 0%,
			#5bb52d 28.85%,
			#66cc32 100%
		);
	}

	&.completed {
		& .${linearProgressClasses.bar} {
			border-radius: 26px;
			background-image: linear-gradient(
				180deg,
				#888888 0%,
				#777777 30.73%,
				#666666 43.75%,
				#555555 100%
			);
		}
	}
`;

export const TextContainer = styled("div")`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 7%;
	//line-height: 1.4em;
	font-family: Baloo;
	font-style: normal;
	font-size: 1em;
	//-webkit-text-stroke-width: 0.15em;
	//-webkit-text-stroke-color: #000;
	//paint-order: stroke fill;
`;

// export const Text = styled("div")`
// 	display: flex;
// 	justify-content: center;
// 	width: 60%;
// `;

export const Counter = styled("div")`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
`;
